// extracted by mini-css-extract-plugin
module.exports = {"servicePage":"ConciergePosting_servicePage__3R0bU","decorativeImage":"ConciergePosting_decorativeImage__1a1Lr","separator":"ConciergePosting_separator__b3GRM"};